module.exports = __webpack_public_path__ + "static/architect-c7b6a64dc59dbbcd16036c176a4a7a8f.svg";